import React from 'react';
import { useTranslation } from 'react-i18next';
import IconParagraph from '../IconParagraph';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';
import { Heading } from '@innovationnorway/cl-react';

const Esa = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack">
      <Heading level={3} className="margin-bottom--3">
        {tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa')}
      </Heading>
      <IconParagraph
        faIcon={'fa-light fa-plus'}
        header={tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Add')}
      >
        <p>{tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Add.Text')}</p>
      </IconParagraph>
      <IconParagraph
        faIcon={'fa-light fa-edit'}
        header={tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Edit')}
      >
        <p>{tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Edit.Text')}</p>
      </IconParagraph>
      <IconParagraph
        faIcon={'fa-light fa-list'}
        header={tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Use')}
      >
        <p>{tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Use.Text')}</p>
      </IconParagraph>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.FUNDS.BASE}>
        {tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Link')}
      </Link>
    </div>
  );
};

export default Esa;
